import {
    FETCH_NOTIFICATIONS_LIST,
    FETCH_LOCATIONS_LIST,
    SAVE_NOTIFICATION,
    DELETE_NOTIFICATION,
    DELETE_MULTIPLE_NOTIFICATIONS,
    MODIFY_NOTIFICATION_DATA,
    FETCH_NOTIFICATION_DATA,
    MODIFY_RECURRENT_NOTIFICATIONS_DATA
} from "../actions/types"

const INITIAL_STATE = {
    downloadnotificationData:[],
    notificationList:[],
    locationList: [],
    allPagination: {
        currentPage: 1,
        totalPages: 0
    },
    notificationParams: {}
}
let calculateTotalPages = (totalCount, pageSize) => {
    return (totalCount && pageSize) ? (Math.floor(totalCount / pageSize) + (totalCount % pageSize ? 1 : 0)) : 1
}

export default (state = INITIAL_STATE, action) =>  {
        switch (action.type) {
        case FETCH_NOTIFICATIONS_LIST:
               return {
                ...state, 
                notificationList: action.payload.hasOwnProperty('results') ? action.payload.results : action.payload,
                allPagination: {
                    currentPage: action.payload.current_page,
                    totalPages: calculateTotalPages(action.payload.total_count, action.payload.page_size)
                   },
                   notificationParams: action.param
             }
        case FETCH_NOTIFICATION_DATA:
                return {
                    ...state,
                    downloadnotificationData: action.payload.hasOwnProperty('results') ? action.payload.results : action.payload
                }
        case FETCH_LOCATIONS_LIST:
            return {...state, locationList: action.payload.locationData }
        case SAVE_NOTIFICATION:
            return {...state, notificationList: [...state.notificationList].concat(action.payload)}
        case DELETE_NOTIFICATION:
            return {...state, notificationList: [...state.notificationList.filter( val=>val !== action.payload.data)]}
        case DELETE_MULTIPLE_NOTIFICATIONS:
            return {...state, notificationList: [...state.notificationList.filter( val=> !action.payload.includes(val.id))]}
        case MODIFY_NOTIFICATION_DATA:
            if(action.payload){
                const notificationList = state.notificationList.filter( val => val.id !== action.payload.id )
                return { ...state ,notificationList : [...notificationList, action.payload]}
            }
             else 
                return state
        case MODIFY_RECURRENT_NOTIFICATIONS_DATA:
            if(action.payload){
                const notificationList = state.notificationList.filter( val => val.event_id !== action.payload[0].event_id )
                return { ...state ,notificationList : [...notificationList, ...action.payload]}
            }
             else 
                return state
        default:
            return state;
    }
}